export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'Come ricevo il materiale?',
    answer:
      'Riceverai accesso immediato dopo il pagamento. Tutti i PDF sono pronti da scaricare e usare. Puoi stamparli, salvarli sul tuo cellulare o consultarli da qualsiasi dispositivo. Il download è veloce e diretto.',
  },
  {
    question: 'È solo per allenatori esperti?',
    answer:
      'No. Il Volume 6 e i bonus sono progettati anche per chi inizia. Se invece hai esperienza, i Volumi 1-5 ti permettono di strutturare conoscenze che avevi disorganizzate. Funziona per entrambi i livelli.',
  },
  {
    question: 'Funziona in tutta Italia e in tutta Europa?',
    answer:
      "Sì. Il sistema è universale. La tecnica dell'atletica è la stessa in Italia, Spagna, Argentina o USA. Il linguaggio è italiano tecnico standard e i regolamenti di World Athletics si applicano dappertutto.",
  },
  {
    question: 'Posso modificare e personalizzare i PDF?',
    answer:
      'Sì. Sono file PDF standard che puoi aprire con qualsiasi programma, stampare, condividere con il tuo staff o personalizzare secondo le necessità del tuo club. Sono tuoi.',
  },
  {
    question: 'È solo per atletica o include altri sport?',
    answer:
      "È 100% per l'atletica leggera: velocità, ostacoli, salti, lanci, fondo e marcia. Se alleni altre discipline, questo sistema non fa per te. Ma se alleni atletica, è completamente specifico.",
  },
  {
    question: 'Come funziona la garanzia di 7 giorni?',
    answer:
      "Dopo l'acquisto hai 7 giorni pieni per verificare il sistema. Se il contenuto non è quello descritto, scrivici una mail. Controlleremo il tuo caso e, se non riusciamo a risolverlo, ti rimborsiamo il 100%. Nessuna domanda fastidiosa.",
  },
]
